import { Button, Col, DatePicker, Form, Input, Radio, Result, Row, Select, Space, Spin  } from 'antd';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormOTPInput } from '../../../shared/components/crmFormElement/FormInput';
import { COMMON_ERROR, GUTTOR_SPACE, MOBILE_MASK_REGEX } from '../../../shared/constants/commonConstants';
import { RootState } from '../../../store';
import {
  generateOTP, getAuthModes, getClaimDocumentsForABHA, reloadLinkedRecordsList,
  saveDocsWithoutAbhaAction, saveDocuments, updateAuthFetchError, setAuthModes, setDocumentListForAbha, updateAbhaFormData,
  updateLinkedRecord, verifyOTP,
} from '../../../store/actions/linkContextAction';
import { LinkContextModel } from '../../../store/models/linkContextModel';
import {centeredNotification } from '../../../utils/utility';
import { GENDER_LIST, HEALTH_INFO_TYPE, LINK_RECORDS_COMPONENTS, LINK_RECORDS_COMPONENTS_CLAIMS_DATA,
  LINK_RECORDS_WITHOUT_ABHA, LINK_RECORDS_WITHOUT_ABHA_CLAIM_DATA } from '../abdmConstants';
import Uploader from './Uploader';
import { ReactComponent as RoundTickIcon } from '../../../assets/images/svg/i_green_tick.svg';
import FileListWithAction from './FileListWithAction';
import { dateDisabledAfterToday, getDocumentList, getSentenceCase } from '../abdmUtils';
import { ID_CARD_TYPE } from '../../../shared/constants/crmConstants';
import { setGetHealthIdCard, setHealthCardType } from '../../../store/actions/newAdmissionAction';
import InputMask from '../../../shared/components/crmFormElement/InputMask/InputMask';
import TextArea from 'antd/lib/input/TextArea';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';

export const EnterAbha = ({ handlers: { goNext, form, setComponentNav } }: any): ReactElement => {
  const dispatch = useDispatch();
  const { abhaFormData = {} } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const { linkAbhaClick } = useSelector((state: RootState): any => state?.admissionDetails || {});

  const onSuccessFetch = ({ modes, purpose }: any): any => {
    dispatch(setAuthModes(modes));
  };
  const onErrorFetch = (err: any): any => {
    centeredNotification(err);
  };

  const onSubmit = (): any => {
    linkAbhaClick ?
      setComponentNav(LINK_RECORDS_COMPONENTS_CLAIMS_DATA) :
      setComponentNav(LINK_RECORDS_COMPONENTS);
    form.validateFields().then((): any => {
      dispatch(updateAbhaFormData({ ...abhaFormData, ...form?.getFieldsValue() }));
      dispatch(setAuthModes([])); // clearing the auth modes and the error state before next fetch auth mode
      dispatch(updateAuthFetchError(false));
      if (linkAbhaClick) {
        dispatch(getAuthModes(onSuccessFetch, onErrorFetch));
      }
      goNext();
    });
  };

  const onContinueWithoutAbha = (): any => {
    linkAbhaClick ?
      setComponentNav(LINK_RECORDS_WITHOUT_ABHA_CLAIM_DATA) :
      setComponentNav(LINK_RECORDS_WITHOUT_ABHA);
    goNext();
  };

  return (
    <div className="enter-abha">
      <Form.Item label="Enter ABHA Number or ABHA Address" name="abhaNumber"
        rules={[{ required: true, message: 'ABHA Number is required' }]}>
        <Input placeholder="Enter ABHA Number or ABHA Address" />
      </Form.Item>
      <div className="buttons">
        <Row gutter={GUTTOR_SPACE} justify="center" className="mb-sm">
          <strong className="text-primary mouse-pointer" onClick={onContinueWithoutAbha}>Continue without ABHA</strong>
        </Row>
        <Row gutter={GUTTOR_SPACE} justify="center">
          <Button type="primary" onClick={onSubmit}>Submit</Button>
        </Row>
      </div>
    </div>
  );
};

export const UploadFiles = ({ handlers: { goNext, form }, isEdit = false, selectedRecord }: any ): ReactElement => {
  const [isErr, setIsErr] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { fileList = {} } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const { linkMoreDocsToAbha } = useSelector((state: RootState): any => state?.admissionDetails || {});

  const onSubmit = (): any => {
    let finalFiles: any[] = [];
    Object.values(fileList).map((files: any): any => {
      if (files?.length) {
        finalFiles = finalFiles.concat(files);
      }
      return files;
    });
    if (finalFiles.length) {
      setIsErr(false);
      setIsLoading(true);
      if (isEdit) {
        const data = {
          providerId: selectedRecord?.providerId,
          patientContextId: selectedRecord?.id,
          contextReference: selectedRecord?.contextReference,
          documentList: getDocumentList(fileList, isEdit),
          hiTypes: Object.keys(fileList),
        };
        dispatch(updateLinkedRecord(data, onSuccess, onError));
      } else {
        dispatch(getAuthModes(onSuccessFetch, onErrorFetch));
      }
    } else {
      setIsErr(true);
    }
  };

  const onSuccessFetch = ({ modes, purpose }: any): any => {
    setIsLoading(false);
    dispatch(setAuthModes(modes));
    goNext();
  };

  const onErrorFetch = (err: any): any => {
    setIsLoading(false);
    centeredNotification(err);
  };

  const onSuccess = (): any => {
    setIsLoading(false);
    goNext();
  };

  const onError = (err: any): any => {
    setIsLoading(false);
    centeredNotification(err);
  };
  return (
    <div className="upload-docs">
      {HEALTH_INFO_TYPE.map((ele: any): any => (
        <Row key={ele?.value} className="m-adjust">
          <Col md={10} className="mt-v-align">
            <strong>{ele?.label}</strong>
          </Col>
          <Col md={14}>
            <Uploader linkedTo={ele?.value} />
          </Col>
          {
            fileList[ele?.value]?.length ?
              <div className="docs-section">
                <FileListWithAction linkedTo={ele?.value} />
              </div> : <></>
          }
        </Row>
      ))}
      {
        isErr &&
        <Row gutter={GUTTOR_SPACE}>
          <Col md={24}>
            <Text type="danger">Please upload at least one file.</Text>
          </Col>
        </Row>
      }
      <Row justify="center" gutter={GUTTOR_SPACE} className="buttons">
        <Col md={12}>
          <Button type="primary" onClick={onSubmit} loading={isLoading}>{linkMoreDocsToAbha ? 'Upload Health Records' : 'Link Health Records'}</Button>
        </Col>
      </Row>
    </div>
  );
};
export const SelectAuthModes = ({ handlers: { goNext, form } }: any): ReactElement => {
  const dispatch = useDispatch();
  const { authModes = [], abhaFormData, isAuthFetchError } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});

  const onSubmit = (): any => {
    form.validateFields().then((): any => {
      dispatch(updateAbhaFormData({ ...abhaFormData, ...form.getFieldsValue() }));
      goNext();
    });
  };

  return (
    <div>
      <Form.Item label="Select preferred auth mode" name="authMode" rules={[{ required: true, message: 'Auth mode is required!' }]}>
        {authModes?.length === 0 && !isAuthFetchError ? <div className="loadingSpinner"><Spin/></div> :
        <Radio.Group>
          <Space direction="vertical">
            {
              authModes?.map((ele: string): any => (
                <Radio key={ele} value={ele}> {getSentenceCase(ele)} </Radio>
              ))
            }
          </Space>
        </Radio.Group>
      }
      </Form.Item>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col>
          <Button type="primary" onClick={onSubmit} disabled={isAuthFetchError}>Submit</Button>
        </Col>
      </Row>
    </div>
  );
};

const DemoGraphicsForm = (props: any): any => {
  return (
    <Row gutter={GUTTOR_SPACE}>
      <Col md={24}>
        <Form.Item name="userName" label="Patient Name" rules={[{ required: true, message: 'Patient name is required!' }]}>
          <Input placeholder="Enter patient name" allowClear={true} />
        </Form.Item>
      </Col>
      <Col md={12}>
        <Form.Item name="mobile" label="Mobile No." rules={[
          { required: true, message: 'Mobile no. is required!' },
          { required: true, pattern: new RegExp(MOBILE_MASK_REGEX), message: 'Please enter valid mobile No.' }]}>
          <InputMask
            allowClear={true}
            data-testid="mobile-no"
            mask="+\91 999 9999 999"
            placeholder="Enter phone No."
            maskChar=" "
          />
        </Form.Item>
      </Col>
      <Col md={12}>
        <Form.Item name="userDob" label="DOB" rules={[{ required: true, message: 'DOB is required!' }]}>
          <DatePicker placeholder="Enter patient date of birth" disabledDate={dateDisabledAfterToday} />
        </Form.Item>
      </Col>
      <Col md={24}>
        <Form.Item name="userGender" label="Gender" rules={[{ required: true, message: 'Gender is required!' }]}>
          <Radio.Group>
            <Space direction="vertical">
              {
                GENDER_LIST?.map((ele: any): any => (
                  <Radio key={ele?.value} value={ele?.value}> {ele?.label} </Radio>
                ))
              }
            </Space>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export const EnterOTP = ({ handlers: { goNext, form }  }: any): ReactElement => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [countdown, setCountdown] = useState(10 * 60);
  const [isGenerating, setIsGenerating] = useState(false);
  const { abhaFormData } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});

  useEffect((): any => {
    setIsGenerating(true);
    dispatch(generateOTP(onSuccessGenOtp, onErrorGenOtp));
  }, []);

  useEffect((): any => {
    let interval: NodeJS.Timeout;
    if (countdown > 0) {
      interval = setInterval((): any => {
        setCountdown((prevCountdown: any): any => prevCountdown - 1);
      }, 1000);
    }
    return (): any => {
      clearInterval(interval);
    };
  }, [countdown]);

  const onSuccessGenOtp = ({ transactionId }: any): any => {
    setIsGenerating(false);
    dispatch(updateAbhaFormData({ ...abhaFormData, transactionId }));
  };

  const onErrorGenOtp = (errMsg: string): any => {
    setIsGenerating(false);
    centeredNotification(errMsg);
  };

  const onSubmit = (): any => {
    form.validateFields().then((): any => {
      dispatch(updateAbhaFormData({ ...abhaFormData, ...form.getFieldsValue() }));
      setIsLoading(true);
      dispatch(verifyOTP(onSuccess, onError));
    });
  };

  const onSuccess = (auth: any): any => {
    setIsLoading(false);
    dispatch(updateAbhaFormData({ ...abhaFormData, userInfo: auth }));
    goNext();
  };

  const onError = (errMsg: string): any => {
    setIsLoading(false);
    centeredNotification(errMsg);
  };
  const onResendOtp = (): any => {
    setIsGenerating(true);
    dispatch(generateOTP(onSuccessGenOtp, onErrorGenOtp));
    setCountdown(10 * 60);
  };
  const formatCountdown = (timeInSeconds: number): string => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = (timeInSeconds % 60);
    const time = minutes < 10 ? `0${minutes}` : minutes;
    const timeSeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${time}:${timeSeconds}`;
  };

  return (
    <React.Fragment>
      {
        abhaFormData?.authMode === 'DEMOGRAPHICS' ?
          <DemoGraphicsForm /> :
          <Row gutter={GUTTOR_SPACE} justify="center">
            <Col className="abha-otp-modal">
              <FormOTPInput
                form={form}
                autoFocus={true}
                length={6}
                className="otpContainer"
                inputClassName="otpInput"
              />
              <div className="text-right resend">
                <div>
                  <Button
                    type="text"
                    className={countdown > 0 ? 'deactivatedstate' : 'activestate'}
                    onClick={onResendOtp}
                    disabled={countdown > 0}
                  >
                    Resend OTP
                  </Button>
                </div>
                {countdown > 0 ?
                  <div> Resend OTP in {formatCountdown(countdown)}</div> : <></>}
              </div>
            </Col>
          </Row>
      }
      <Row gutter={GUTTOR_SPACE} justify="center" className="mt-md">
        <Col>
          <Button disabled={isGenerating} type="primary" loading={isLoading} onClick={onSubmit}>
            {isGenerating ? (abhaFormData?.authMode === 'DEMOGRAPHICS' ? 'Fetching information...' : 'Generating OTP...') : 'Submit'}
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export const UserInfo = ({ handlers: { goNext, form } }: any): ReactElement => {
  const { abhaFormData: { userInfo } = {}, documentList } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const { linkAbhaClick } = useSelector((state: RootState): any => state?.admissionDetails || {});
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { uploadedFiles } = useSelector((state: RootState): NewAdmissionState => state?.newAdmission);

  useEffect((): any => {
    if (userInfo) {
      const { name, monthOfBirth, dayOfBirth, yearOfBirth, gender } = userInfo?.patient || {};
      form.setFieldsValue({
        name,
        dob: moment(`${monthOfBirth}/${dayOfBirth}/${yearOfBirth}`),
        gender,
      });
    }
  }, [userInfo]);

  const getUploadedDocuments = (): any => {
    uploadedFiles?.map((ele: any, index: number): any => {
      const temp = {};
      temp['documentName'] = ele?.name;
      temp['documentGuid'] = ele?.docPath || ele?.response?.uploadedDetails?.map((element: any): any => {
        if (element?.fileGuid !== undefined && element?.fileGuid !== null) {
          temp['documentGuid'] = element?.fileGuid;
        }
      });
      temp['documenttype'] = ele?.fileType || ele?.type;
      documentList?.push(temp);
    });
    dispatch(setDocumentListForAbha(documentList));
    goNext();
  };
  const onSubmitDocs = (): any => {
    setIsLoading(true);
    linkAbhaClick ? getUploadedDocuments() : dispatch(saveDocuments(onSuccess, onError));
    dispatch(reloadLinkedRecordsList());
  };

  const onSuccess = (): any => {
    setIsLoading(false);
    goNext();
  };

  const onError = (errMsg: string): any => {
    setIsLoading(false);
    centeredNotification(errMsg);
  };

  return (
    <React.Fragment>
      <Row gutter={GUTTOR_SPACE}>
        <Col md={24}>
          <Form.Item name="name">
            <Input disabled={true} className="form-text-disabled" placeholder="Enter name" />
          </Form.Item>
        </Col>
        <Col md={24}>
          <Form.Item name="dob">
            <DatePicker disabled={true} placeholder="Enter DOB" />
          </Form.Item>
        </Col>
        <Col md={24}>
          <Form.Item name="gender">
            <Select
              className="gray-select"
              disabled={true}
              placeholder="Select gender"
              options={[{ label: 'Male', value: 'M' }, { label: 'Female', value: 'F' }]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col>
          <Button type="primary" onClick={onSubmitDocs} loading={isLoading}>Submit</Button>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export const FinalPage = ({ handlers: { goNext, form } }: any): ReactElement => {
  const { abhaFormData, fileList } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});

  return (
    <React.Fragment>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col>
          <RoundTickIcon />
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col className="text-center mt-md">
          <strong>Selected records have been linked to your ABHA ID<br />{abhaFormData?.abhaNumber || 'XXXXXXXXXXXXXXXXX'}</strong>
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col md={24}>
          <ul>
            {
              Object.keys(fileList)
                .filter((key: any): boolean => !!fileList[key]?.length)
                .map((ele: string): any => (
                  <li key={ele}>{ele}</li>
                ))
            }
          </ul>
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col>
          <Button onClick={(): any => goNext(-1)}>Close</Button>
        </Col>
      </Row>
    </React.Fragment>
  );
};
export const FinalPageForClaimDetail = ({ handlers: { goNext, form }}: any, match: any): ReactElement => {
  const dispatch = useDispatch();

  const onSuccessFetch = (): any => {
    centeredNotification('Success', 'success');
  };
  useEffect((): any => {
    dispatch(getClaimDocumentsForABHA(onSuccessFetch));
  }, []);
  return <>
    {
      <div className="upload-docs">
        <Result
          status="success"
          title="The health records associated with this claim will be linked with Patient's ABHA"
        />
      </div>
    }
  </>;
};

export const DeepLinkUserInfo = ({ handlers: { goNext, form } }: any): ReactElement => {
  const { abhaFormData, documentList } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const { uploadedFiles } = useSelector((state: RootState): NewAdmissionState => state?.newAdmission);
  const { linkAbhaClick } = useSelector((state: RootState): any => state?.admissionDetails || {});
  const dispatch = useDispatch();
  const getUploadedDocuments = (): any => {
    uploadedFiles?.map((ele: any, index: number): any => {
      const temp = {};
      temp['documentName'] = ele?.name;
      temp['documentGuid'] = ele?.docPath || ele?.response?.uploadedDetails?.map((element: any): any => {
        if (element?.fileGuid !== undefined && element?.fileGuid !== null) {
          temp['documentGuid'] = element?.fileGuid;
        }
      });
      temp['documenttype'] = ele?.fileType || ele?.type;
      documentList?.push(temp);
    });
    dispatch(setDocumentListForAbha(documentList));
    goNext();
  };
  const onSubmit = (): any => {
    const userInfo = {
      patient: {
        name: form?.getFieldsValue()?.deeplinkName,
        gender: form?.getFieldsValue()?.deeplinkGender,
        mobileNo: form?.getFieldsValue()?.deeplinkMobileNo?.replace(/\s/g, ''),
        dayOfBirth: moment(form?.getFieldsValue()?.deeplinkDOB)?.format('DD'),
        monthOfBirth: moment(form?.getFieldsValue()?.deeplinkDOB)?.format('MM'),
        yearOfBirth: moment(form?.getFieldsValue()?.deeplinkDOB)?.format('YYYY'),
      },
    };
    form.validateFields().then((): any => {
      if (linkAbhaClick) {
        dispatch(updateAbhaFormData({ ...abhaFormData, userInfo }));
        getUploadedDocuments();
        return;
      }
      dispatch(updateAbhaFormData({ ...abhaFormData, ...form.getFieldsValue() }));
      goNext();
    });
  };

  const openIDCardModal = (cardType: string): any => {
    goNext(-1);
    dispatch(setHealthCardType(cardType));
    dispatch(setGetHealthIdCard(true));
  };

  return (
    <div className="link-without-abha">
      <Row gutter={GUTTOR_SPACE}>
        <Col md={24}>
          <Form.Item label="Patient Name" name="deeplinkName" rules={[{ required: true, message: 'Patient Name is required!' }]}>
            <Input placeholder="Enter patient name" allowClear={true} />
          </Form.Item>
        </Col>
        <Col md={24}>
          <Form.Item name="deeplinkMobileNo" label="Mobile No." rules={[
            { required: true, message: 'Mobile no. is required!' },
            { required: true, pattern: new RegExp(MOBILE_MASK_REGEX), message: 'Please enter valid mobile No.' }]}>
            <InputMask
              allowClear={true}
              data-testid="mobile-no"
              mask="+\91 999 9999 999"
              placeholder="Enter phone No."
              maskChar=" "
            />
          </Form.Item>
        </Col>
        <Col md={24}>
          <Form.Item name="deeplinkGender" label="Gender" rules={[{ required: true, message: 'Gender is required!' }]}>
            <Radio.Group>
              <Space direction="vertical">
                {
                  GENDER_LIST?.map((ele: any): any => (
                    <Radio key={ele?.value} value={ele?.value}> {ele?.label} </Radio>
                  ))
                }
              </Space>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col md={24}>
          <Form.Item name="deeplinkDOB" label="Date of Birth" rules={[{ required: true, message: 'DOB is required!' }]}>
            <DatePicker allowClear={true} placeholder="Enter D.O.B." disabledDate={dateDisabledAfterToday} />
          </Form.Item>
        </Col>
      </Row>
      <div className="buttons">
        <Row justify="center">
          <strong className="text-primary mouse-pointer" onClick={(): any => openIDCardModal(ID_CARD_TYPE.HEALTH)}>Create ABHA</strong>
        </Row>
        <Row justify="center" className="mt-sm">
          <Button type="primary" onClick={onSubmit}>Submit</Button>
        </Row>
      </div>
    </div>
  );
};

export const CareContextDetails = ({ handlers: { goNext, form } }: any): ReactElement => {
  const { abhaFormData } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const dispatch = useDispatch();

  const onSuccessFetch = ({ modes, purpose }: any): any => {
    dispatch(setAuthModes(modes));
  };
  const onErrorFetch = (err: any): any => {
    centeredNotification(err);
  };
  const onSubmit = (): any => {
    form.validateFields().then((): any => {
      dispatch(updateAbhaFormData({ ...abhaFormData, ...form.getFieldsValue() }));
      goNext();
      dispatch(getAuthModes(onSuccessFetch, onErrorFetch));
    });
  };
  return (
    <div className="care-context-details">
      <Form.Item label="Patient ID/ Registration No." name="referenceNumber" rules={[{ required: true, message: 'Patient ID/ Registration No. is required' }]}>
        <Input placeholder="Enter Patient ID/ Registration No." />
      </Form.Item>
      <Form.Item label="Care Context Description" name="careContextDesc" rules={[{ required: false, message: '' }]}>
        <TextArea placeholder="Enter Care Context Description" />
      </Form.Item>
      <div>
        <h5>Example of Care Context Description:</h5>
        <ul className="care-context-description-example">
          <li>
            OPD - Orthopedics
          </li>
          <li>
            OPD with Dr. Shekhar
          </li>
          <li>
            IPD - Caesarean Section
          </li>
          <li>
            Dialysis
          </li>
          <li>
            PMJAY ID - PXXX239
          </li>
          <li>
            Child's immunization
          </li>
        </ul>
      </div>
      <div className="buttons">
        <Row gutter={GUTTOR_SPACE} justify="center">
          <Button type="primary" onClick={onSubmit}>Submit</Button>
        </Row>
      </div>
    </div>
  );
};

export const UploadFilesWithoutAbha = ({ handlers: { goNext, form } }: any): ReactElement => {
  const [isErr, setIsErr] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { fileList = {} } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const onSubmit = (): any => {
    let finalFiles: any[] = [];
    Object.values(fileList).map((files: any): any => {
      if (files?.length) {
        finalFiles = finalFiles.concat(files);
      }
      return files;
    });
    if (finalFiles.length) {
      setIsErr(false);
      setIsLoading(true);
      dispatch(saveDocsWithoutAbhaAction(onCallback));
    } else {
      setIsErr(true);
    }
  };

  const onCallback = (resp: any): any => {
    if (resp === true) {
      goNext();
    } else {
      centeredNotification(resp || COMMON_ERROR);
    }
  };

  return (
    <div className="upload-docs">
      {HEALTH_INFO_TYPE.map((ele: any): any => (
        <Row key={ele?.value} className="m-adjust">
          <Col md={10} className="mt-v-align">
            <strong>{ele?.label}</strong>
          </Col>
          <Col md={14}>
            <Uploader linkedTo={ele?.value} />
          </Col>
          {
            fileList[ele?.value]?.length ?
              <div className="docs-section">
                <FileListWithAction linkedTo={ele?.value} />
              </div> : <></>
          }
        </Row>
      ))}
      {
        isErr &&
        <Row gutter={GUTTOR_SPACE}>
          <Col md={24}>
            <Text type="danger">Please upload at least one file.</Text>
          </Col>
        </Row>
      }
      <Row justify="center" gutter={GUTTOR_SPACE} className="buttons">
      <Col md={12}>
          <Button type="primary" onClick={onSubmit} loading={isLoading}>Link Health Records</Button>
      </Col>
      </Row>
    </div>
  );
};

export const FinalPageWithoutAbha = ({ handlers: { goNext, form } }: any): ReactElement => {
  const { fileList } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const { linkAbhaClick } = useSelector((state: RootState): any => state?.admissionDetails || {});
  const dispatch = useDispatch();

  const onSuccessFetch = (): any => {
    centeredNotification('Success', 'success');
  };

  useEffect((): any => {
    if (linkAbhaClick) {
      dispatch(getClaimDocumentsForABHA(onSuccessFetch));
    }
  }, []);

  return (
    <React.Fragment>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col>
          <RoundTickIcon />
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col className="text-center mt-md">
          <strong>Documents uploaded Successfully</strong><br />
          <span>A SMS has been sent to your registered phone no.</span>
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center" className="mt-md">
        <Col md={24}>
          <ul>
            {
              Object.keys(fileList)
                .filter((key: any): boolean => !!fileList[key]?.length)
                .map((ele: string): any => (
                  <li key={ele}>{ele}</li>
                ))
            }
          </ul>
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE} justify="center">
        <Col>
          <Button onClick={(): any => goNext(-1)}>Close</Button>
        </Col>
      </Row>
    </React.Fragment>
  );
};
